import React from "react"
import { formatInteger } from "../../../../utils/formatters"
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../../../components/ui/card"
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../../../components/ui/table"

const FLAG_BASE = "https://flag.vercel.app/s"
const regionNames = new Intl.DisplayNames(["en"], { type: "region" })

const TopCountries = ({ rows, hasData = true }) => {
  const data = rows || []

  if (!hasData) {
    return (
      <Card className="md:col-span-2 p-6 dark:bg-transparent flex flex-col items-center justify-center text-center">
        <CardTitle className="mb-1">Learners by country</CardTitle>
        <CardDescription>
          Not enough location data yet — this fills in automatically as learners log in.
        </CardDescription>
      </Card>
    )
  }

  return (
    <Card className="md:col-span-2 p-0 dark:bg-transparent">
      <CardHeader className="pt-5">
        <CardTitle>Learners by country</CardTitle>
        <CardDescription>Top countries in the last 12 months</CardDescription>
      </CardHeader>
      <CardContent className="p-0 pb-2">
        <Table className="border-t">
          <TableHeader>
            <TableRow>
              <TableHead className="pl-5">Country</TableHead>
              <TableHead className="text-right">Learners</TableHead>
              <TableHead className="text-right pr-5">Change</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map((row) => (
              <TableRow key={row?.code}>
                <TableCell className="pl-5">
                  <span className="inline-flex items-center gap-2">
                    <img src={`${FLAG_BASE}/${row?.code}.svg`} alt={`Flag of ${row?.code}`} className="h-3.5 w-5 rounded object-cover" width={20} height={14} />
                    <span className="text-xs">{regionNames.of(row?.code) ?? row?.code}</span>
                  </span>
                </TableCell>
                <TableCell className="text-right text-muted-foreground tabular-nums">{formatInteger(row?.learners)}</TableCell>
                <TableCell className="text-right pr-5 tabular-nums text-muted-foreground">
                  {row?.delta > 0 ? "+" : ""}{row?.delta}%
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}

export default TopCountries